import React from "react";
import AdminLayout from "../../../components/Layout/AdminLayout";
import messages from "../../../locale/jsonMessages";
import SmtpSetup from "./SmtpSetup";
import { restrictUrls } from '../../../helpers/adminPrivileges';

export default async function action({ intl, store }) {

    const title = intl?.formatMessage(messages.smtpCredentialsLabel)

    // From Redux Store
    let isAdminAuthenticated = store.getState().runtime.isAdminAuthenticated;
    let adminPrivileges = store.getState().account.privileges && store.getState().account.privileges.privileges;
    let privileges = store.getState().listSettings && store.getState().listSettings.privileges;

    if (!isAdminAuthenticated) {
        return { redirect: '/siteadmin/login' }
    }
    // Admin restriction
    if (!restrictUrls('/siteadmin/smtp-setup', adminPrivileges, privileges)) {
        return { redirect: '/siteadmin' };
    }

    return {
        title,
        component: <AdminLayout> <SmtpSetup /></AdminLayout>
    }
}